export default __webpack_public_path__ + "static/media/mapFrameRectangleExplorer.33f6037e.jpg";